export const getLocalIPs = async () => {
    const ips = [];
    const rtc = new RTCPeerConnection();
    
    rtc.createDataChannel('');
    rtc.createOffer().then(offer => rtc.setLocalDescription(offer));
    rtc.onicecandidate = (event) => {
      if (event.candidate) {
        const candidate = event.candidate.candidate;
        if (candidate) {
          const parts = candidate.split(' ');
          const ip = parts[4];
          if (ip && !ips.includes(ip)) {
            ips.push(ip);
            return ips
          }
        }
      }
    };
    return ips
  };